var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "call-chat",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.223,
    height: 21.681,
    viewBox: "0 0 18.223 21.681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4646",
    "data-name": "Path 4646",
    d: "M22.591,19.789a.94.94,0,0,1,.23,1.05,4.131,4.131,0,0,1-2.927,2.588,4.432,4.432,0,0,1-4.068-.589,19.312,19.312,0,0,1-7.6-9.139,15.04,15.04,0,0,1-.837-8.468c.5-2.005,2-3.062,4.576-3.231a.936.936,0,0,1,1.043.776c.351,1.214.727,2.3,1.294,4.041.193.637.078.911-.495,1.189l-.075.034a22.407,22.407,0,0,1-2.144.935.656.656,0,0,0-.488.833A14.641,14.641,0,0,0,15.464,17.5c.478.4.545.437,1.06.152.329-.186.657-.4.976-.6.261-.166.522-.329.786-.488.759-.44,1.016-.4,1.609.264.735.823,1.7,1.9,2.7,2.96Z",
    transform: "translate(-7.101 -1.997)",
    fill: "#ffbdbf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4647",
    "data-name": "Path 4647",
    d: "M35.8,12.444c-2.8,0-5.071,1.792-5.071,4a3.347,3.347,0,0,0,.721,2.053l-.83,2.374a.168.168,0,0,0,.251.2L32.95,19.74a6.01,6.01,0,0,0,2.852.694c2.794,0,5.071-1.792,5.071-3.994s-2.276-4-5.071-4Zm-2.319,4.7a.683.683,0,1,1,.683-.683A.683.683,0,0,1,33.483,17.148Zm2.258,0a.683.683,0,1,1,.683-.683A.683.683,0,0,1,35.741,17.148Zm2.259,0a.683.683,0,1,1,.683-.683A.683.683,0,0,1,38,17.148Z",
    transform: "translate(-22.649 -8.905)",
    fill: "#ffbdbf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallChat);
export default __webpack_public_path__ + "static/media/call-chat.727a6306197c6953fa0fc6e6dde6b019.svg";
export { ForwardRef as ReactComponent };